export default {
  data() {
    return {
      sortValue: "",
    };
  },
  methods: {
    sortList(sortId) {
      this.sortValue = sortId;
      const sortFunctions = {
        closest: this.sortPackagesByStartDate,
        minDuration: this.sortPackagesByTotalNights,
        maxDuration: this.sortPackagesByTotalNightsDecreamental,
        minPrice: this.sortPackagesTotalPrice,
        maxPrice: this.sortPackagesTotalPriceDecreamental,
      };

      const sortFunction = sortFunctions[sortId];
      if (sortFunction) sortFunction.call();
    },

    sortPackagesByStartDate() {
      this.getFilteredResults.sort((a, b) => {
        return new Date(a.startDate) - new Date(b.startDate);
      });
    },

    sortPackagesTotalPriceDecreamental() {
      this.getFilteredResults.sort((a, b) => {
        return b.totalPrice - a.totalPrice;
      });
    },
    sortPackagesTotalPrice() {
      this.getFilteredResults.sort((a, b) => {
        return a.totalPrice - b.totalPrice;
      });
    },

    sortPackagesByTotalNights() {
      this.getFilteredResults.sort((a, b) => a.numberOfNightsOfStay - b.numberOfNightsOfStay);
    },

    sortPackagesByTotalNightsDecreamental() {
      this.getFilteredResults.sort((a, b) => b.numberOfNightsOfStay - a.numberOfNightsOfStay);
    },
  },
  watch: {
    getLoading: {
      handler() {
        this.sortList(this.sortValue);
      },
      deep: true,
    },
  },
};
